import BaseHole from 'scripts/models/api/common/hole';

export default BaseHole.extend({});